module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('flow-list', {
    attrs: {
      "caseId": _vm.caseId,
      "path": _vm.path
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a7ce64e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/instance/follow.vue
// module id = 1970
// module chunks = 2